import { BaseComparerBuilder } from './BaseComparerBuilder';
import { IComparer } from './IComparer';

export class DateComparerBuilder<T> extends BaseComparerBuilder<T, Date> {
    buildComparer(
        selector: (model: T) => Date | undefined | null,
        ascending: boolean,
        undefinedLast = false
    ): IComparer<T> {
        return {
            compare: (x: T, y: T): number => {
                const xValue: Date | undefined | null = selector(x);
                const yValue: Date | undefined | null = selector(y);

                if (xValue === undefined && yValue === undefined) {
                    return 0;
                }

                if (xValue == null) {
                    return (
                        1 *
                        this.getOrderMultiplier(ascending) *
                        (undefinedLast ? (ascending ? 1 : -1) : ascending ? -1 : 1)
                    );
                }

                if (yValue == null) {
                    return (
                        -1 *
                        this.getOrderMultiplier(ascending) *
                        (undefinedLast ? (ascending ? 1 : -1) : ascending ? -1 : 1)
                    );
                }

                if (xValue > yValue) {
                    return 1 * this.getOrderMultiplier(ascending);
                }

                if (xValue < yValue) {
                    return -1 * this.getOrderMultiplier(ascending);
                }

                return 0;
            },
        };
    }
}
